import { AccordionProps } from "@made-people/blueprint-accordion";

export const Accordion: AccordionProps = {
  icons: {},
  heading: {
    variants: {
      headingSize: "md",
    },
  },
};
